import {createFeatureSelector, createSelector} from "@ngrx/store";
import {IHostingResourcesState} from "../reducers/hosting-resources.reducer";
import {DbStoreState} from "../reducers";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getHostingResourcesState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.hostingResources);

export const getHostingResources = createSelector(getHostingResourcesState,
  (state: IHostingResourcesState) => state.hostingResources ? state.hostingResources.entities : null
);

export const getHostingResourcesLoading  = createSelector(getHostingResourcesState,
  (state: IHostingResourcesState) =>
    state.loading
);

export const getHostingResourcesLoaded = createSelector(getHostingResourcesState,
  (state: IHostingResourcesState) =>
    state.loaded
);

export const getHostingResourcesByWebsite = (websiteId: number) => createSelector(getHostingResourcesState,
  (state: IHostingResourcesState) =>
    state.entities && state.entities[websiteId] && state.entities[websiteId].entities ? state.entities[websiteId].entities : (state.hostingResources && state.hostingResources.entities ? state.hostingResources.entities.storage : null)
);

export const getHostingResourcesByWebsiteLoading = (websiteId: number) => createSelector(getHostingResourcesState,
  (state: IHostingResourcesState) =>
    state.loading
);

export const getHostingResourcesByWebsiteLoaded = (websiteId: number) => createSelector(getHostingResourcesState,
  (state: IHostingResourcesState) =>
    state.loaded
);
